"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePagination = void 0;
const react_1 = require("react");
const defaultValues = {
    page: 1,
    pageSize: 5,
};
const usePagination = (initialValues) => {
    const [page, setPage] = (0, react_1.useState)(initialValues?.page || defaultValues.page);
    const [pageSize, setPageSize] = (0, react_1.useState)(initialValues?.pageSize || defaultValues.pageSize);
    const onPageChange = (_, currentPage) => {
        setPage(currentPage + 1);
    };
    const updatePageSize = (size) => {
        setPage(1);
        setPageSize(size);
    };
    return { page, pageSize, onPageChange, updatePageSize };
};
exports.usePagination = usePagination;
//# sourceMappingURL=usePagination.js.map